<template>
  <div class="campanha-interna-campanhas-vue mt-3">
    <div class="campanha-interna-campanhas-vue__bootstrap-modals">
      <Modal
        modal-id="modalCampanhaInternaCampanhaAudienciaPreview"
        title="Usuários na audiência"
        dialog-class="modal-xl"
      >
        <template #body>
          <div class="campanha-interna-audiencias-vue">
            <div class="campanha-interna-audiencias-vue__preview-body">
              <div class="row campanha-interna-audiencias-vue__preview-hero mb-3">
                <div class="col-6 text-center">
                  <div class="campanha-interna-audiencias-vue__preview-hero-num">
                    {{ audienciaPreviewStats.total_usuarios_distintos }}
                  </div>
                  <div class="campanha-interna-audiencias-vue__preview-hero-label">USUÁRIOS ENCONTRADOS</div>
                </div>
                <div class="col-6 text-center">
                  <div class="campanha-interna-audiencias-vue__preview-hero-num">
                    {{ audienciaPreviewStats.total_lojas_distintas }}
                  </div>
                  <div class="campanha-interna-audiencias-vue__preview-hero-label">EMPRESAS</div>
                </div>
              </div>

              <p
                v-if="audienciaPreviewStats.total_vinculos !== audienciaPreviewStats.total_usuarios_distintos"
                class="text-muted small text-center mb-2"
              >
                Vínculos usuário–loja no total: {{ audienciaPreviewStats.total_vinculos }}
              </p>

              <p v-if="audienciaPreviewStats.amostra_truncada" class="text-muted small text-center mb-3">
                Lista abaixo é uma amostra; há mais registros além dos exibidos.
              </p>

              <div
                v-if="audienciaPreviewGroupedByLoja.length"
                class="campanha-interna-audiencias-vue__preview-list"
              >
                <div
                  v-for="grupo in audienciaPreviewGroupedByLoja"
                  :key="grupo.loja_id"
                  class="campanha-interna-audiencias-vue__preview-loja-card"
                >
                  <div class="campanha-interna-audiencias-vue__preview-loja-head">
                    <i class="fas fa-building campanha-interna-audiencias-vue__preview-loja-icon" aria-hidden="true"></i>
                    <div class="flex-grow-1 min-w-0">
                      <div class="campanha-interna-audiencias-vue__preview-loja-title">
                        {{ grupo.loja_nome }} ({{ grupo.loja_id }})
                      </div>
                      <div class="campanha-interna-audiencias-vue__preview-loja-sub">
                        {{ grupo.users.length }}
                        {{ grupo.users.length === 1 ? 'usuário' : 'usuários' }} na amostra
                      </div>
                    </div>
                  </div>
                  <div class="campanha-interna-audiencias-vue__preview-user-list">
                    <div
                      v-for="(u, ui) in grupo.users"
                      :key="`${grupo.loja_id}-${u.user_id}-${ui}`"
                      class="campanha-interna-audiencias-vue__preview-user-row"
                    >
                      <i class="fas fa-user campanha-interna-audiencias-vue__preview-user-icon" aria-hidden="true"></i>
                      <span class="campanha-interna-audiencias-vue__preview-user-name">{{ u.user_name }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <p v-else class="text-muted text-center small mb-0">
                Nenhum destinatário encontrado para esta audiência.
              </p>
            </div>
          </div>
        </template>
        <template #footer>
          <button type="button" class="btn btn-primary btn-sm" @click="closeAudienciaPreviewModal">Fechar</button>
        </template>
      </Modal>

      <Modal
        modal-id="modalCampanhaInternaCampanhaErro"
        :title="errorModalTitle"
        dialog-class="modal-dialog-centered"
      >
        <template #body>
          <p v-if="errorModalMessage" class="mb-2">{{ errorModalMessage }}</p>
          <ul
            v-if="errorModalItems.length"
            class="list-unstyled mb-0 campanha-interna-campanhas-vue__error-list"
          >
            <li v-for="(row, i) in errorModalItems" :key="i" class="small">
              <template v-if="row.label">
                <strong>{{ row.label }}:</strong>
                {{ row.text }}
              </template>
              <template v-else>{{ row.text }}</template>
            </li>
          </ul>
        </template>
        <template #footer>
          <button type="button" class="btn btn-primary btn-sm" @click="closeErrorModal">Fechar</button>
        </template>
      </Modal>

      <Modal
        modal-id="modalCampanhaInternaCampanhaExcluir"
        title="Excluir campanha"
        dialog-class="modal-dialog-centered"
      >
        <template #body>
          <p v-if="deleteModalItem" class="mb-0">
            Excluir a campanha <strong>{{ deleteModalItem.nome }}</strong>? Esta ação não pode ser desfeita.
          </p>
        </template>
        <template #footer>
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            :disabled="deleteModalDeleting"
            @click="closeDeleteConfirmModal"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            :disabled="deleteModalDeleting"
            @click="executeDeleteConfirmed"
          >
            {{ deleteModalDeleting ? 'Excluindo…' : 'Excluir' }}
          </button>
        </template>
      </Modal>

      <Modal
        modal-id="modalCampanhaInternaCampanhaInsights"
        :title="insightsModalTitle"
        dialog-class="modal-lg modal-dialog-centered"
      >
        <template #body>
          <div v-if="insightsLoading" class="text-center py-4">Carregando…</div>
          <div v-else-if="insightsPayload" class="campanha-interna-campanhas-vue__insights">
            <div class="row text-center mb-3 campanha-interna-campanhas-vue__insights-kpis">
              <div class="col-6 col-md-3 mb-3">
                <div class="small text-muted mb-1">Visualizações</div>
                <div class="h5 mb-0 font-weight-bold">{{ insightsPayload.impressoes.total_visualizacoes }}</div>
                <div class="text-caption text-muted">registros com data</div>
              </div>
              <div class="col-6 col-md-3 mb-3">
                <div class="small text-muted mb-1">Usuários (únicos)</div>
                <div class="h5 mb-0 font-weight-bold">{{ insightsPayload.impressoes.usuarios_distintos }}</div>
              </div>
              <div class="col-6 col-md-3 mb-3">
                <div class="small text-muted mb-1">Fechamentos</div>
                <div class="h5 mb-0 font-weight-bold">{{ insightsPayload.impressoes.total_fechamentos_modal }}</div>
                <div class="text-caption text-muted">modal dispensado</div>
              </div>
              <div class="col-6 col-md-3 mb-3">
                <div class="small text-muted mb-1">Cliques (total)</div>
                <div class="h5 mb-0 font-weight-bold">{{ insightsPayload.cliques.total }}</div>
              </div>
            </div>

            <h6 class="small font-weight-bold text-uppercase mb-2">Cliques por botão / CTA</h6>
            <div class="table-responsive">
              <table class="table table-sm table-bordered mb-0 campanha-interna-campanhas-vue__insights-table">
                <thead>
                  <tr>
                    <th scope="col">Posição no popup</th>
                    <th scope="col">Rótulo</th>
                    <th scope="col">Destino</th>
                    <th scope="col" class="text-right">Cliques</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in insightsPayload.cliques.por_botao" :key="'ins-' + i">
                    <td>{{ insightsBotaoOnde(row) }}</td>
                    <td>{{ row.label }}</td>
                    <td class="text-break small">{{ row.href }}</td>
                    <td class="text-right font-weight-bold">{{ row.total }}</td>
                  </tr>
                  <tr v-if="!insightsPayload.cliques.por_botao.length">
                    <td colspan="4" class="text-muted text-center small">Nenhum clique registrado ainda.</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="text-muted small mt-3 mb-0">
              Visualizações podem ser &gt; usuários únicos quando a campanha permite várias exibições por usuário.
            </p>
          </div>
        </template>
        <template #footer>
          <button type="button" class="btn btn-primary btn-sm" @click="closeInsightsModal">Fechar</button>
        </template>
      </Modal>
    </div>

    <!-- Lista -->
    <div v-if="page === 'list'">
      <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap campanha-interna-campanhas-vue__toolbar">
        <h5 class="mb-0 campanha-interna-campanhas-vue__title"></h5>
        <Button :href="routes.create" variant="success" size="sm" depth>
          <Icon type="fas" icon="plus" color="white" class="mr-1" />
          Adicionar
        </Button>
      </div>

      <div v-if="loading" class="text-center py-4">Carregando...</div>
      <div v-else class="campanha-interna-campanhas-vue__card campanha-interna-campanhas-vue__datatable-wrap">
        <DataTable
          name="Campanhas internas"
          :headers="headers"
          :data="items"
          :pesquisa="true"
          :options="tableOptions"
          :itens-per-page-options="[10, 20, 30, 50, 100, -1]"
        >
          <template v-slot:[`item.status`]="{ item }">
            <span
              class="campanha-interna-vue-status-pill"
              :class="
                isStatusAtivo(item)
                  ? 'campanha-interna-vue-status-pill--ativa'
                  : 'campanha-interna-vue-status-pill--inativa'
              "
            >
              {{ isStatusAtivo(item) ? 'Ativa' : 'Inativa' }}
            </span>
          </template>
          <template v-slot:[`item.audiencia`]="{ item }">
            {{ item.audiencia ? item.audiencia.nome : '—' }}
          </template>
          <template v-slot:[`item.data_inicio`]="{ item }">
            {{ formatCampanhaDate(item.data_inicio) }}
          </template>
          <template v-slot:[`item.data_fim`]="{ item }">
            {{ formatCampanhaDate(item.data_fim) || '—' }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex justify-content-end align-items-center flex-wrap campanha-interna-campanhas-vue__row-actions">
              <Button
                variant="secondary"
                outline
                size="sm"
                table
                class="mr-1 mb-1"
                title="Insights — impressões e cliques"
                :loading="insightsLoadingId === item.id"
                @click="openInsightsModal(item)"
              >
                <i class="fas fa-chart-bar"></i>
              </Button>
              <Button
                v-if="audienciaIdForCampanha(item)"
                variant="primary"
                outline
                size="sm"
                table
                class="mr-1 mb-1"
                title="Ver usuários da audiência (totais e amostra)"
                :loading="testingAudienciaId === audienciaIdForCampanha(item)"
                @click="runAudienciaPreview(item)"
              >
                <i class="fas fa-vial"></i>
              </Button>
              <Button
                :href="editUrl(item.id)"
                variant="primary"
                size="sm"
                table
                class="mr-1 mb-1"
                title="Editar"
              >
                <i class="fas fa-edit"></i>
              </Button>
              <Button variant="danger" size="sm" table class="mb-1" title="Excluir" @click="openDeleteConfirmModal(item)">
                <i class="fas fa-trash"></i>
              </Button>
            </div>
          </template>
        </DataTable>
      </div>
    </div>

    <!-- Formulário -->
    <vuetify-wrapper v-else>
      <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap campanha-interna-campanhas-vue__toolbar">
        <h5 class="mb-0 campanha-interna-campanhas-vue__title"></h5>
        <Button :href="routes.index" variant="cancel" size="sm">Voltar</Button>
      </div>

      <v-card elevation="1" class="campanha-interna-campanhas-vue__card">
        <v-card-text>
          <Input
            v-model="form.nome"
            name="nome"
            id="campanha-interna-nome"
            label="Nome"
            placeholder="Nome interno da campanha"
            required
          />

          <Autocomplete
            v-model="audienciaSelection"
            name="audiencia"
            label="Audiência"
            placeholder="Selecione a audiência"
            :items="audienciaItems"
            :multiple="false"
            classe="mb-4"
          />

          <div class="form-row">
            <div class="col-md-6">
              <Input v-model="form.data_inicio" name="data_inicio" id="data_inicio" label="Data início" type="date" required />
            </div>
            <div class="col-md-6">
              <Input v-model="form.data_fim" name="data_fim" id="data_fim" label="Data fim (opcional)" type="date" />
            </div>
          </div>

          <div class="mb-3">
            <label class="small d-block mb-1" id="label-frequencia-exibicao">Frequência de exibição</label>
            <RadioGroup
              v-model="form.frequencia_exibicao"
              name="frequencia_exibicao"
              :options="frequenciaExibicaoOptions"
              ariaLabelledby="label-frequencia-exibicao"
            />
          </div>

          <div class="mb-3">
            <label class="small d-block mb-1" id="label-contexto-exibicao">Onde exibir</label>
            <RadioGroup
              v-model="form.contexto_exibicao"
              name="contexto_exibicao"
              :options="contextoExibicaoOptions"
              ariaLabelledby="label-contexto-exibicao"
            />
          </div>

          <div v-if="form.contexto_exibicao === 'rota_especifica'" class="mb-4">
            <label class="small mb-1 d-block" for="rota_nome">Tela do painel</label>
            <select id="rota_nome" v-model="form.rota_nome" class="form-control" required>
              <option value="" disabled>Selecione…</option>
              <option v-for="(label, key) in rotasPainel" :key="key" :value="key">{{ label }}</option>
            </select>
          </div>

          <Input
            v-model="prioridadeStr"
            name="prioridade"
            id="prioridade"
            label="Prioridade (maior = exibida primeiro em empate)"
            type="number"
          />

          <div class="mb-4">
            <Check v-model="form.status">Ativa</Check>
          </div>

          <v-divider class="my-4" />

          <h6 class="subtitle-1 mb-2 campanha-interna-campanhas-vue__section-title">Conteúdo do popup</h6>
          <p class="text-caption mb-2 campanha-interna-campanhas-vue__hint">
            Monte os blocos e use o preview ao lado ou abaixo.
          </p>

          <div class="mb-3">
            <Check v-model="form.conteudo.exibir_nome_no_titulo">Exibir nome da campanha no título do modal</Check>
          </div>
          <div class="form-group mb-4">
            <label class="small mb-1 d-block" for="campanha-interna-modal-largura">Largura do modal</label>
            <select id="campanha-interna-modal-largura" v-model="form.conteudo.modal_largura" class="form-control">
              <option value="auto">Automática (acompanha o conteúdo)</option>
              <option value="lg">Grande (fixa)</option>
              <option value="xl">Extra grande</option>
            </select>
            <p class="text-caption small text-muted mb-0 mt-1">
              “Automática” limita a largura máxima e evita modal largo demais em textos curtos.
            </p>
          </div>

          <div class="row">
            <div class="col-lg-7">
              <div v-for="(block, idx) in form.conteudo.blocks" :key="'blk-' + idx" class="border rounded p-3 mb-3 campanha-interna-campanhas-vue__block-editor">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <strong>{{ blockTypeLabel(block.type) }}</strong>
                  <div>
                    <Button variant="secondary" size="xs" class="mr-1" :disabled="idx === 0" @click="moveBlock(idx, -1)">↑</Button>
                    <Button variant="secondary" size="xs" class="mr-1" :disabled="idx === form.conteudo.blocks.length - 1" @click="moveBlock(idx, 1)">↓</Button>
                    <Button variant="danger" size="xs" outline @click="removeBlock(idx)">Remover</Button>
                  </div>
                </div>

                <template v-if="block.type === 'text'">
                  <div class="form-group">
                    <label class="small mb-1 d-block" :for="'al-t-' + idx">Alinhamento</label>
                    <select :id="'al-t-' + idx" v-model="block.align" class="form-control">
                      <option v-for="opt in alignOptions" :key="'t-' + opt.value" :value="opt.value">{{ opt.label }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label class="small mb-1 d-block" :for="'ts-t-' + idx">Tamanho do texto no popup</label>
                    <select :id="'ts-t-' + idx" v-model="block.text_size" class="form-control">
                      <option v-for="opt in textSizeOptions" :key="'ts-' + opt.value" :value="opt.value">{{ opt.label }}</option>
                    </select>
                  </div>
                  <Input v-model="block.title" :name="'t'+idx" :label="'Título (opcional)'" />
                  <div class="form-group">
                    <label class="small mb-1">Texto</label>
                    <textarea v-model="block.body" class="form-control" rows="3"></textarea>
                  </div>
                </template>
                <template v-else-if="block.type === 'image'">
                  <div class="form-group">
                    <label class="small mb-1 d-block" :for="'al-i-' + idx">Alinhamento</label>
                    <select :id="'al-i-' + idx" v-model="block.align" class="form-control">
                      <option v-for="opt in alignOptions" :key="'i-' + opt.value" :value="opt.value">{{ opt.label }}</option>
                    </select>
                  </div>
                  <Input v-model="block.src" :name="'img'+idx" label="URL da imagem" required />
                  <Input v-model="block.alt" :name="'alt'+idx" label="Texto alternativo" />
                  <div class="form-group">
                    <label class="small mb-1 d-block" :for="'img-mw-' + idx">Largura máxima no popup</label>
                    <select :id="'img-mw-' + idx" v-model="block.image_max_width" class="form-control">
                      <option v-for="opt in imageMaxWidthOptions" :key="'imw-' + opt.value" :value="opt.value">
                        {{ opt.label }}
                      </option>
                    </select>
                    <small class="text-muted">Reduz imagens muito grandes sem alterar o arquivo.</small>
                  </div>
                </template>
                <template v-else-if="block.type === 'video'">
                  <div class="form-group">
                    <label class="small mb-1 d-block" :for="'al-v-' + idx">Alinhamento</label>
                    <select :id="'al-v-' + idx" v-model="block.align" class="form-control">
                      <option v-for="opt in alignOptions" :key="'v-' + opt.value" :value="opt.value">{{ opt.label }}</option>
                    </select>
                  </div>
                  <Input v-model="block.url" :name="'vid'+idx" label="URL do vídeo (YouTube ou MP4)" required />
                </template>
                <template v-else-if="block.type === 'button'">
                  <div class="form-group">
                    <label class="small mb-1 d-block" :for="'al-b-' + idx">Alinhamento</label>
                    <select :id="'al-b-' + idx" v-model="block.align" class="form-control">
                      <option v-for="opt in alignOptions" :key="'b-' + opt.value" :value="opt.value">{{ opt.label }}</option>
                    </select>
                  </div>
                  <Input v-model="block.label" :name="'bl'+idx" label="Rótulo" required />
                  <Input v-model="block.href" :name="'bh'+idx" label="Link (https://… ou /rota)" />
                  <small class="text-muted d-block mb-2">Opcional. Vazio = botão só dispara ação / métrica, sem abrir link.</small>
                  <div class="form-group">
                    <label class="small mb-1 d-block" :for="'btn-var-' + idx">Estilo (Bootstrap)</label>
                    <select :id="'btn-var-' + idx" v-model="block.variant" class="form-control">
                      <option v-for="v in buttonVariantOptions" :key="v" :value="v">{{ v }}</option>
                    </select>
                  </div>
                  <div class="mb-2">
                    <Check v-model="block.outline">Contorno (outline)</Check>
                  </div>
                  <Input
                    v-model="block.icon"
                    :name="'bic'+idx"
                    label="Ícone Font Awesome (opcional)"
                    placeholder="bell ou fas fa-bell"
                  />
                  <p class="text-caption small text-muted mb-2">
                    <strong>Formato:</strong> Font Awesome 5 (sólido = <code>fas</code>). Pode usar só o nome
                    (<code>thumbs-up</code>, <code>bell</code>), ou <code>fa-thumbs-up</code>,
                    <code>fa fa-thumbs-up</code> (estilo antigo), ou o par completo
                    <code>fas fa-thumbs-up</code>. Deixe vazio para só texto.
                  </p>
                  <div class="form-group">
                    <label class="small d-block mb-1">Cor customizada (opcional)</label>
                    <div class="d-flex flex-wrap align-items-center">
                      <input
                        type="color"
                        class="form-control campanha-interna-campanhas-vue__btn-color-native"
                        :value="block.custom_hex || '#0d6efd'"
                        @input="block.custom_hex = $event.target.value"
                      />
                      <input
                        v-model="block.custom_hex"
                        type="text"
                        class="form-control ml-2 campanha-interna-campanhas-vue__btn-color-text"
                        placeholder="#RRGGBB"
                      />
                      <button type="button" class="btn btn-link btn-sm py-0 ml-1" @click="block.custom_hex = ''">
                        Limpar cor
                      </button>
                    </div>
                    <small class="text-muted">Se preenchida, substitui o estilo Bootstrap acima.</small>
                  </div>
                </template>
                <template v-else-if="block.type === 'button_row'">
                  <div class="form-group">
                    <label class="small mb-1 d-block" :for="'al-br-' + idx">Alinhamento da linha</label>
                    <select :id="'al-br-' + idx" v-model="block.align" class="form-control">
                      <option v-for="opt in alignOptions" :key="'br-' + opt.value" :value="opt.value">{{ opt.label }}</option>
                    </select>
                  </div>
                  <p class="text-caption small text-muted mb-2">
                    Vários botões na mesma linha (quebra em telas estreitas). Mínimo de um botão. Link pode ficar
                    vazio (sem URL). Ícone: mesmo formato do bloco “botão” (<code>bell</code> ou
                    <code>fas fa-bell</code>).
                  </p>
                  <div
                    v-for="(btn, j) in block.buttons"
                    :key="'br-edit-' + idx + '-' + j"
                    class="border rounded p-2 mb-2 campanha-interna-campanhas-vue__row-btn"
                  >
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <span class="small font-weight-bold">Botão {{ j + 1 }}</span>
                      <Button
                        variant="danger"
                        size="xs"
                        outline
                        :disabled="!block.buttons || block.buttons.length <= 1"
                        @click="removeRowButton(block, j)"
                      >
                        Remover
                      </Button>
                    </div>
                    <Input v-model="btn.label" :name="'brl'+idx+'-'+j" label="Rótulo" required />
                    <Input v-model="btn.href" :name="'brh'+idx+'-'+j" label="Link (https://… ou /rota)" />
                    <div class="form-group">
                      <label class="small mb-1 d-block" :for="'br-var-'+idx+'-'+j">Estilo (Bootstrap)</label>
                      <select :id="'br-var-'+idx+'-'+j" v-model="btn.variant" class="form-control">
                        <option v-for="v in buttonVariantOptions" :key="v" :value="v">{{ v }}</option>
                      </select>
                    </div>
                    <div class="mb-2">
                      <Check v-model="btn.outline">Contorno (outline)</Check>
                    </div>
                    <Input
                      v-model="btn.icon"
                      :name="'bric'+idx+'-'+j"
                      label="Ícone Font Awesome (opcional)"
                      placeholder="bell ou fas fa-bell"
                    />
                    <div class="form-group">
                      <label class="small d-block mb-1">Cor customizada (opcional)</label>
                      <div class="d-flex flex-wrap align-items-center">
                        <input
                          type="color"
                          class="form-control campanha-interna-campanhas-vue__btn-color-native"
                          :value="btn.custom_hex || '#0d6efd'"
                          @input="btn.custom_hex = $event.target.value"
                        />
                        <input
                          v-model="btn.custom_hex"
                          type="text"
                          class="form-control ml-2 campanha-interna-campanhas-vue__btn-color-text"
                          placeholder="#RRGGBB"
                        />
                        <button type="button" class="btn btn-link btn-sm py-0 ml-1" @click="btn.custom_hex = ''">
                          Limpar cor
                        </button>
                      </div>
                    </div>
                  </div>
                  <Button variant="outline-primary" size="sm" @click="addRowButton(block)">+ Botão na linha</Button>
                </template>
                <template v-else-if="block.type === 'spacer'">
                  <Input v-model="block.heightStr" :name="'sp'+idx" label="Altura (px)" type="number" />
                </template>
              </div>

              <div class="d-flex flex-wrap">
                <Button v-for="bt in blockTypes" :key="bt" variant="outline-primary" size="sm" class="mr-1 mb-1" @click="addBlock(bt)">
                  + {{ bt }}
                </Button>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="campanha-interna-campanhas-vue__preview border rounded p-3">
                <div class="small font-weight-bold mb-2">Preview</div>
                <CampanhaInternaPopupBlocks :conteudo="normalizedPreviewConteudo" />
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="px-4 pb-4 flex-wrap campanha-interna-campanhas-vue__actions">
          <Button variant="primary" depth :loading="saving" @click="submitForm">Salvar</Button>
          <span v-if="previewMessage" class="text-body-2">{{ previewMessage }}</span>
        </v-card-actions>
      </v-card>
    </vuetify-wrapper>
  </div>
</template>

<script>
import axios from 'axios';

import DataTable from '../ui/DataTable.vue';
import Input from '../ui/Input.vue';
import Check from '../ui/Check.vue';
import RadioGroup from '../ui/RadioGroup.vue';
import Autocomplete from '../ui/Autocomplete.vue';
import Icon from '../ui/Icon.vue';
import Button from '../ui/Button.vue';
import Modal from '../ui/Modal.vue';
import CampanhaInternaPopupBlocks from './CampanhaInternaPopupBlocks.vue';

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
};

/** Evita seguir redirect 302 do Laravel com PUT (gera 405 no index). */
const axiosSaveOptions = {
  headers: jsonHeaders,
  maxRedirects: 0,
};

function csrf() {
  const m = document.querySelector('meta[name="csrf-token"]');
  return m ? m.getAttribute('content') : '';
}

function todayISODate() {
  const d = new Date();
  const z = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}`;
}

function defaultConteudo() {
  return {
    version: 1,
    exibir_nome_no_titulo: true,
    modal_largura: 'auto',
    blocks: [
      { type: 'text', title: '', body: 'Olá! Este é um exemplo de texto.', align: 'left', text_size: 'md' },
    ],
  };
}

/** Rótulos amigáveis para chaves de validação do backend. */
function campanhaInternaFieldLabel(key) {
  const map = {
    campanha_interna_audiencia_id: 'Audiência',
    rota_nome: 'Rota do painel',
    nome: 'Nome',
    status: 'Status',
    data_inicio: 'Data de início',
    data_fim: 'Data de término',
    frequencia_exibicao: 'Frequência de exibição',
    contexto_exibicao: 'Contexto de exibição',
    prioridade: 'Prioridade',
    conteudo: 'Conteúdo',
    'conteudo.exibir_nome_no_titulo': 'Exibir nome no título do modal',
    'conteudo.modal_largura': 'Largura do modal',
  };
  return map[key] || String(key).replace(/_/g, ' ');
}

export default {
  name: 'CampanhaInternaCampanhasApp',
  components: {
    DataTable,
    Input,
    Check,
    RadioGroup,
    Autocomplete,
    Icon,
    Button,
    Modal,
    CampanhaInternaPopupBlocks,
  },
  data() {
    return {
      page: 'list',
      loading: false,
      saving: false,
      testing: false,
      items: [],
      campanhaId: null,
      routes: {},
      meta: { audiencias: [], rotas_painel: {} },
      tableOptions: { page: 1, itemsPerPage: 30 },
      form: {
        nome: '',
        campanha_interna_audiencia_id: null,
        status: true,
        data_inicio: todayISODate(),
        data_fim: '',
        frequencia_exibicao: 'unica',
        contexto_exibicao: 'rota_especifica',
        rota_nome: '',
        prioridade: 0,
        conteudo: defaultConteudo(),
      },
      prioridadeStr: '0',
      previewMessage: '',
      audienciaPreviewStats: {
        total_vinculos: 0,
        total_usuarios_distintos: 0,
        total_lojas_distintas: 0,
        amostra_truncada: false,
      },
      audienciaPreviewRows: [],
      testingAudienciaId: null,
      errorModalTitle: 'Atenção',
      errorModalMessage: '',
      errorModalItems: [],
      deleteModalItem: null,
      deleteModalDeleting: false,
      insightsCampanhaNome: '',
      insightsLoading: false,
      insightsLoadingId: null,
      insightsPayload: null,
      headers: [
        { text: '#', value: 'id', sortable: true, width: '72px' },
        { text: 'Nome', value: 'nome', sortable: true },
        { text: 'Audiência', value: 'audiencia', sortable: false },
        { text: 'Início', value: 'data_inicio', sortable: true, width: '108px' },
        { text: 'Fim', value: 'data_fim', sortable: true, width: '108px' },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Ações', value: 'actions', sortable: false, align: 'end', width: '220px' },
      ],
      blockTypes: ['text', 'image', 'video', 'button', 'button_row', 'spacer'],
      buttonVariantOptions: ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'],
      alignOptions: [
        { value: 'left', label: 'À esquerda' },
        { value: 'center', label: 'Centro' },
        { value: 'right', label: 'À direita' },
      ],
      textSizeOptions: [
        { value: 'sm', label: 'Pequeno' },
        { value: 'md', label: 'Normal (padrão)' },
        { value: 'lg', label: 'Grande' },
        { value: 'xl', label: 'Muito grande' },
      ],
      imageMaxWidthOptions: [
        { value: '', label: 'Automática (responsiva, limitada ao modal)' },
        { value: 200, label: 'Máx. 200 px' },
        { value: 240, label: 'Máx. 240 px' },
        { value: 280, label: 'Máx. 280 px' },
        { value: 320, label: 'Máx. 320 px' },
        { value: 360, label: 'Máx. 360 px' },
        { value: 400, label: 'Máx. 400 px' },
        { value: 480, label: 'Máx. 480 px' },
        { value: 560, label: 'Máx. 560 px' },
        { value: 640, label: 'Máx. 640 px' },
      ],
      frequenciaExibicaoOptions: [
        { value: 'unica', label: 'Uma vez por usuário (nesta campanha)' },
        { value: 'sempre', label: 'Sempre que atender às regras (dentro do período)' },
      ],
      contextoExibicaoOptions: [
        { value: 'primeira_abertura', label: 'Primeira abertura (rota início)' },
        { value: 'rota_especifica', label: 'Tela específica' },
      ],
    };
  },
  computed: {
    audienciaItems() {
      return (this.meta.audiencias || []).map((a) => ({ id: a.id, value: a.nome }));
    },
    rotasPainel() {
      return this.meta.rotas_painel || {};
    },
    audienciaSelection: {
      get() {
        const id = this.form.campanha_interna_audiencia_id;
        if (id == null) return null;
        return this.audienciaItems.find((x) => x.id === id) || null;
      },
      set(val) {
        this.form.campanha_interna_audiencia_id = val && val.id != null ? val.id : null;
      },
    },
    audienciaPreviewGroupedByLoja() {
      const rows = this.audienciaPreviewRows || [];
      const map = new Map();
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const lid = row.loja_id;
        if (!map.has(lid)) {
          map.set(lid, {
            loja_id: lid,
            loja_nome: row.loja_nome || '—',
            users: [],
          });
        }
        map.get(lid).users.push(row);
      }
      return Array.from(map.values()).sort((a, b) =>
        String(a.loja_nome).localeCompare(String(b.loja_nome), 'pt-BR', { sensitivity: 'base' })
      );
    },
    insightsModalTitle() {
      return this.insightsCampanhaNome ? `Insights — ${this.insightsCampanhaNome}` : 'Insights';
    },
    normalizedPreviewConteudo() {
      const blocks = (this.form.conteudo.blocks || []).map((b) => {
        if (b.type === 'spacer') {
          return { type: 'spacer', height: parseInt(b.heightStr || b.height || 16, 10) || 16 };
        }
        if (b.type === 'button') {
          return {
            ...b,
            align: b.align || 'left',
            variant: b.variant || 'primary',
            outline: !!b.outline,
          };
        }
        if (b.type === 'button_row') {
          return {
            type: 'button_row',
            align: b.align || 'left',
            buttons: (b.buttons || []).map((btn) => ({
              ...btn,
              variant: btn.variant || 'primary',
              outline: !!btn.outline,
            })),
          };
        }
        if (b.type === 'image') {
          const out = { ...b, align: b.align || 'left' };
          const mw = b.image_max_width;
          if (mw !== '' && mw != null && mw !== undefined) {
            const n = Number(mw);
            if (!Number.isNaN(n) && n > 0) {
              out.image_max_width = n;
            } else {
              delete out.image_max_width;
            }
          } else {
            delete out.image_max_width;
          }
          return out;
        }
        if (b.type === 'text') {
          const valid = ['sm', 'md', 'lg', 'xl'];
          const ts = valid.includes(b.text_size) ? b.text_size : 'md';
          return { ...b, align: b.align || 'left', text_size: ts };
        }
        if (b.type === 'video') {
          return { ...b, align: b.align || 'left' };
        }
        return { ...b };
      });
      return { version: 1, blocks };
    },
  },
  watch: {
    prioridadeStr(v) {
      const n = parseInt(v, 10);
      this.form.prioridade = Number.isNaN(n) ? 0 : n;
    },
  },
  mounted() {
    const cfg = window.campanhaInternaCampanhasConfig || {};
    this.routes = cfg.routes || {};
    this.meta = cfg.meta || {};
    this.page = cfg.page === 'form' ? 'form' : 'list';
    this.campanhaId = cfg.campanhaId != null ? Number(cfg.campanhaId) : null;

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf();

    if (this.page === 'list') {
      this.loadList();
    } else if (this.campanhaId) {
      this.loadCampanha();
    } else {
      this.syncSpacerHeights();
    }
  },
  methods: {
    isStatusAtivo(item) {
      const s = item && item.status;
      if (s === true || s === 1 || s === '1') return true;
      if (s === false || s === 0 || s === '0') return false;
      return !!s;
    },
    /** Exibe data da API (YYYY-MM-DD ou ISO) como dd/mm/aaaa. */
    formatCampanhaDate(value) {
      if (value == null || value === '') return '';
      const raw = String(value).trim();
      const ymd = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (ymd) {
        return `${ymd[3]}/${ymd[2]}/${ymd[1]}`;
      }
      const d = new Date(raw);
      if (!Number.isNaN(d.getTime())) {
        const z = (n) => String(n).padStart(2, '0');
        return `${z(d.getDate())}/${z(d.getMonth() + 1)}/${d.getFullYear()}`;
      }
      return raw;
    },
    editUrl(id) {
      return `${this.routes.base}/${id}/edit`;
    },
    audienciaIdForCampanha(item) {
      if (!item) return null;
      return item.campanha_interna_audiencia_id != null
        ? Number(item.campanha_interna_audiencia_id)
        : item.audiencia && item.audiencia.id != null
          ? Number(item.audiencia.id)
          : null;
    },
    openAudienciaPreviewModal() {
      this.$nextTick(() => {
        $('#modalCampanhaInternaCampanhaAudienciaPreview').modal('show');
      });
    },
    closeAudienciaPreviewModal() {
      $('#modalCampanhaInternaCampanhaAudienciaPreview').modal('hide');
    },
    showErrorModal({ title, message, errors }) {
      this.errorModalTitle = title || 'Atenção';
      this.errorModalMessage = message || '';
      this.errorModalItems = [];
      if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
        Object.keys(errors).forEach((key) => {
          const msgs = errors[key];
          const arr = Array.isArray(msgs) ? msgs : [msgs];
          const label = campanhaInternaFieldLabel(key);
          arr.forEach((m) => {
            if (m != null && String(m).trim() !== '') {
              this.errorModalItems.push({ label, text: String(m) });
            }
          });
        });
      }
      if (!this.errorModalMessage && this.errorModalItems.length) {
        this.errorModalMessage = 'Corrija os campos indicados abaixo.';
      }
      this.$nextTick(() => {
        $('#modalCampanhaInternaCampanhaErro').modal('show');
      });
    },
    closeErrorModal() {
      $('#modalCampanhaInternaCampanhaErro').modal('hide');
    },
    async openInsightsModal(item) {
      if (!item || item.id == null) return;
      this.insightsCampanhaNome =
        item.nome != null && String(item.nome).trim() !== '' ? String(item.nome) : `ID ${item.id}`;
      this.insightsPayload = null;
      this.insightsLoading = true;
      this.insightsLoadingId = item.id;
      this.$nextTick(() => {
        $('#modalCampanhaInternaCampanhaInsights').modal('show');
      });
      const base = String(this.routes.base || '').replace(/\/$/, '');
      try {
        const { data } = await axios.get(`${base}/${item.id}/insights`, { headers: jsonHeaders });
        this.insightsPayload = data;
      } catch (e) {
        this.insightsPayload = null;
        const d = e.response && e.response.data ? e.response.data : {};
        this.showErrorModal({
          title: 'Insights',
          message:
            (typeof d.message === 'string' && d.message) ||
            'Não foi possível carregar os insights desta campanha.',
        });
        $('#modalCampanhaInternaCampanhaInsights').modal('hide');
      } finally {
        this.insightsLoading = false;
        this.insightsLoadingId = null;
      }
    },
    closeInsightsModal() {
      $('#modalCampanhaInternaCampanhaInsights').modal('hide');
      this.insightsPayload = null;
      this.insightsCampanhaNome = '';
    },
    insightsBotaoOnde(row) {
      const b = row.block_index + 1;
      if (row.button_sub_index != null) {
        return `Bloco ${b} · botão ${row.button_sub_index + 1}`;
      }
      return `Bloco ${b}`;
    },
    openDeleteConfirmModal(item) {
      if (!item || item.id == null) return;
      this.deleteModalItem = {
        id: item.id,
        nome: item.nome != null && String(item.nome).trim() !== '' ? String(item.nome) : `ID ${item.id}`,
      };
      this.deleteModalDeleting = false;
      this.$nextTick(() => {
        $('#modalCampanhaInternaCampanhaExcluir').modal('show');
      });
    },
    closeDeleteConfirmModal() {
      $('#modalCampanhaInternaCampanhaExcluir').modal('hide');
      this.deleteModalItem = null;
      this.deleteModalDeleting = false;
    },
    async executeDeleteConfirmed() {
      if (!this.deleteModalItem) return;
      const id = this.deleteModalItem.id;
      this.deleteModalDeleting = true;
      try {
        await axios.delete(`${this.routes.base}/${id}`, { headers: jsonHeaders });
        this.closeDeleteConfirmModal();
        this.loadList();
      } catch (e) {
        const d = e.response && e.response.data ? e.response.data : {};
        this.showErrorModal({
          title: 'Exclusão',
          message:
            (typeof d.message === 'string' && d.message) ||
            'Não foi possível excluir esta campanha.',
        });
      } finally {
        this.deleteModalDeleting = false;
      }
    },
    async runAudienciaPreview(item) {
      const id = this.audienciaIdForCampanha(item);
      if (!id) return;
      const base = (this.routes.audienciasBase || '').replace(/\/$/, '');
      if (!base) {
        this.showErrorModal({
          title: 'Configuração ausente',
          message: 'Configuração de rota de audiências ausente.',
        });
        return;
      }
      this.testingAudienciaId = id;
      try {
        const { data } = await axios.get(`${base}/${id}/preview`, { headers: jsonHeaders });
        this.audienciaPreviewStats = {
          total_vinculos: data.total_vinculos ?? 0,
          total_usuarios_distintos: data.total_usuarios_distintos ?? 0,
          total_lojas_distintas: data.total_lojas_distintas ?? 0,
          amostra_truncada: !!data.amostra_truncada,
        };
        this.audienciaPreviewRows = Array.isArray(data.amostra) ? data.amostra : [];
        this.openAudienciaPreviewModal();
      } catch (e) {
        this.showErrorModal({
          title: 'Preview da audiência',
          message: 'Não foi possível carregar o preview da audiência.',
        });
      } finally {
        this.testingAudienciaId = null;
      }
    },
    blockTypeLabel(type) {
      if (type === 'button_row') return 'Linha de botões';
      return type;
    },
    emptyButtonFields() {
      return {
        label: '',
        href: '',
        variant: 'primary',
        outline: false,
        icon: '',
        custom_hex: '',
      };
    },
    addRowButton(block) {
      if (!Array.isArray(block.buttons)) {
        this.$set(block, 'buttons', []);
      }
      block.buttons.push(this.emptyButtonFields());
    },
    removeRowButton(block, j) {
      if (!Array.isArray(block.buttons) || block.buttons.length <= 1) return;
      block.buttons.splice(j, 1);
    },
    syncSpacerHeights() {
      (this.form.conteudo.blocks || []).forEach((b) => {
        if (b.type === 'spacer' && b.heightStr === undefined) {
          this.$set(b, 'heightStr', String(b.height != null ? b.height : 16));
        }
        if (['text', 'image', 'video', 'button', 'button_row'].includes(b.type) && b.align === undefined) {
          this.$set(b, 'align', 'left');
        }
        if (b.type === 'text' && b.text_size === undefined) {
          this.$set(b, 'text_size', 'md');
        }
        if (b.type === 'button') {
          if (b.variant === undefined) this.$set(b, 'variant', 'primary');
          if (b.outline === undefined) this.$set(b, 'outline', false);
          if (b.icon === undefined) this.$set(b, 'icon', '');
          if (b.custom_hex === undefined) this.$set(b, 'custom_hex', '');
        }
        if (b.type === 'button_row') {
          if (!Array.isArray(b.buttons) || b.buttons.length === 0) {
            this.$set(b, 'buttons', [this.emptyButtonFields()]);
          } else {
            b.buttons.forEach((btn) => {
              if (btn.variant === undefined) this.$set(btn, 'variant', 'primary');
              if (btn.outline === undefined) this.$set(btn, 'outline', false);
              if (btn.icon === undefined) this.$set(btn, 'icon', '');
              if (btn.custom_hex === undefined) this.$set(btn, 'custom_hex', '');
            });
          }
        }
      });
    },
    async loadList() {
      this.loading = true;
      try {
        const { data } = await axios.get(this.routes.indexJson, {
          params: { per_page: 500 },
          headers: jsonHeaders,
        });
        this.items = data.data || [];
      } catch (e) {
        console.error(e);
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    async loadCampanha() {
      this.loading = true;
      try {
        const { data } = await axios.get(`${this.routes.base}/${this.campanhaId}`, { headers: jsonHeaders });
        this.form.nome = data.nome || '';
        this.form.campanha_interna_audiencia_id = data.campanha_interna_audiencia_id;
        this.form.status = !!data.status;
        this.form.data_inicio = data.data_inicio ? String(data.data_inicio).slice(0, 10) : todayISODate();
        this.form.data_fim = data.data_fim ? String(data.data_fim).slice(0, 10) : '';
        this.form.frequencia_exibicao = data.frequencia_exibicao || 'unica';
        this.form.contexto_exibicao = data.contexto_exibicao || 'rota_especifica';
        this.form.rota_nome = data.rota_nome || '';
        this.form.prioridade = data.prioridade != null ? data.prioridade : 0;
        this.prioridadeStr = String(this.form.prioridade);
        if (data.conteudo && data.conteudo.blocks) {
          const saved = data.conteudo;
          const blocks = (saved.blocks || []).map((b) => {
            if (b.type === 'image') {
              const mw = b.image_max_width;
              return {
                ...b,
                image_max_width:
                  mw != null && mw !== '' && !Number.isNaN(Number(mw)) ? Number(mw) : '',
              };
            }
            if (b.type === 'text') {
              const valid = ['sm', 'md', 'lg', 'xl'];
              const ts = b.text_size;
              return { ...b, text_size: valid.includes(ts) ? ts : 'md' };
            }
            return b;
          });
          this.form.conteudo = {
            ...defaultConteudo(),
            ...saved,
            blocks,
            exibir_nome_no_titulo: saved.exibir_nome_no_titulo !== false,
            modal_largura: ['auto', 'lg', 'xl'].includes(saved.modal_largura)
              ? saved.modal_largura
              : 'lg',
          };
        } else {
          this.form.conteudo = defaultConteudo();
        }
        this.syncSpacerHeights();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    addBlock(type) {
      const blocks = this.form.conteudo.blocks || [];
      let b;
      if (type === 'text') b = { type: 'text', title: '', body: '', align: 'left', text_size: 'md' };
      else if (type === 'image') b = { type: 'image', src: '', alt: '', align: 'left', image_max_width: '' };
      else if (type === 'video') b = { type: 'video', url: '', align: 'left' };
      else if (type === 'button') {
        b = {
          type: 'button',
          label: '',
          href: '',
          align: 'left',
          variant: 'primary',
          outline: false,
          icon: '',
          custom_hex: '',
        };
      } else if (type === 'button_row') {
        b = {
          type: 'button_row',
          align: 'left',
          buttons: [this.emptyButtonFields()],
        };
      } else b = { type: 'spacer', heightStr: '16', height: 16 };
      blocks.push(b);
      this.$set(this.form.conteudo, 'blocks', blocks);
    },
    removeBlock(idx) {
      this.form.conteudo.blocks.splice(idx, 1);
    },
    moveBlock(idx, delta) {
      const j = idx + delta;
      const arr = this.form.conteudo.blocks;
      if (j < 0 || j >= arr.length) return;
      const copy = [...arr];
      const t = copy[idx];
      copy[idx] = copy[j];
      copy[j] = t;
      this.$set(this.form.conteudo, 'blocks', copy);
    },
    buildPayload() {
      const largura = this.form.conteudo.modal_largura;
      const conteudo = {
        version: 1,
        exibir_nome_no_titulo: this.form.conteudo.exibir_nome_no_titulo !== false,
        modal_largura: ['auto', 'lg', 'xl'].includes(largura) ? largura : 'auto',
        blocks: (this.form.conteudo.blocks || []).map((b) => {
          if (b.type === 'spacer') {
            const h = parseInt(b.heightStr || b.height || 16, 10);
            return { type: 'spacer', height: Math.min(500, Math.max(0, h)) };
          }
          if (b.type === 'button') {
            const out = {
              type: 'button',
              label: b.label,
              href: b.href != null ? String(b.href).trim() : '',
              align: b.align || 'left',
              variant: b.variant || 'primary',
              outline: !!b.outline,
            };
            const icon = (b.icon || '').trim();
            if (icon) {
              out.icon = icon;
            }
            const hex = (b.custom_hex || '').trim();
            if (hex) {
              out.custom_hex = hex;
            }
            return out;
          }
          if (b.type === 'button_row') {
            return {
              type: 'button_row',
              align: b.align || 'left',
              buttons: (b.buttons || []).map((btn) => {
                const ob = {
                  label: btn.label,
                  href: btn.href != null ? String(btn.href).trim() : '',
                  variant: btn.variant || 'primary',
                  outline: !!btn.outline,
                };
                const icon = (btn.icon || '').trim();
                if (icon) ob.icon = icon;
                const hex = (btn.custom_hex || '').trim();
                if (hex) ob.custom_hex = hex;
                return ob;
              }),
            };
          }
          if (b.type === 'image') {
            const out = {
              type: 'image',
              src: b.src,
              alt: (b.alt || '').trim(),
              align: b.align || 'left',
            };
            const raw = b.image_max_width;
            const mw =
              raw === '' || raw === null || raw === undefined ? null : parseInt(String(raw), 10);
            if (mw != null && !Number.isNaN(mw) && mw >= 50 && mw <= 1200) {
              out.image_max_width = mw;
            }
            return out;
          }
          if (b.type === 'text') {
            const valid = ['sm', 'md', 'lg', 'xl'];
            const ts = valid.includes(b.text_size) ? b.text_size : 'md';
            return {
              type: 'text',
              title: b.title != null ? b.title : '',
              body: b.body != null ? b.body : '',
              align: b.align || 'left',
              text_size: ts,
            };
          }
          if (b.type === 'video') {
            return {
              ...b,
              align: b.align || 'left',
            };
          }
          return { ...b };
        }),
      };
      return {
        nome: this.form.nome,
        campanha_interna_audiencia_id: this.form.campanha_interna_audiencia_id,
        status: this.form.status,
        data_inicio: this.form.data_inicio,
        data_fim: this.form.data_fim || null,
        frequencia_exibicao: this.form.frequencia_exibicao,
        contexto_exibicao: this.form.contexto_exibicao,
        rota_nome: this.form.contexto_exibicao === 'rota_especifica' ? this.form.rota_nome : null,
        prioridade: this.form.prioridade,
        conteudo,
      };
    },
    async submitForm() {
      this.saving = true;
      this.previewMessage = '';
      const payload = this.buildPayload();
      try {
        let res;
        if (this.campanhaId) {
          const updateUrl = this.routes.update || `${String(this.routes.base || '').replace(/\/$/, '')}/${this.campanhaId}`;
          res = await axios.put(updateUrl, payload, axiosSaveOptions);
        } else {
          res = await axios.post(this.routes.store, payload, axiosSaveOptions);
        }
        const raw = res.data && res.data.redirect ? res.data.redirect : this.routes.index;
        // Nova navegação GET explícita (não reaproveita o método PUT do axios)
        let next = raw;
        if (raw && !String(raw).match(/^https?:\/\//i)) {
          try {
            next = new URL(raw, window.location.origin).href;
          } catch (e) {
            next = this.routes.index;
          }
        }
        window.location.assign(next);
      } catch (e) {
        const d = e.response && e.response.data ? e.response.data : {};
        if (e.response && e.response.status === 422) {
          this.showErrorModal({
            title: 'Dados inválidos',
            message: d.message || 'Os dados enviados são inválidos.',
            errors: d.errors,
          });
        } else {
          this.showErrorModal({
            title: 'Não foi possível salvar',
            message:
              (typeof d.message === 'string' && d.message) ||
              (e.message && String(e.message)) ||
              'Não foi possível salvar. Tente novamente.',
          });
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.campanha-interna-campanhas-vue__toolbar {
  gap: 0.5rem;
}
.campanha-interna-campanhas-vue__actions {
  gap: 0.5rem;
}
.campanha-interna-campanhas-vue__datatable-wrap ::v-deep .container-fluid {
  padding-left: 0;
  padding-right: 0;
}
.campanha-interna-campanhas-vue__error-list li + li {
  margin-top: 0.35rem;
}
</style>
